import { Button } from "@/components/ui/button";
import { ShieldAlert, ArrowLeft, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 p-6 relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-600/10 rounded-full blur-[120px]" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-purple-600/10 rounded-full blur-[120px]" />
      
      <div className="max-w-md w-full relative z-10">
        <div className="bg-slate-900/50 backdrop-blur-xl border border-slate-800 rounded-3xl p-8 shadow-2xl shadow-black/50 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-red-500/10 border border-red-500/20 mb-6 group">
            <ShieldAlert className="h-10 w-10 text-red-500 group-hover:scale-110 transition-transform duration-300" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-2">Acceso Denegado</h1>
          <p className="text-slate-400 mb-8 leading-relaxed">
            Lo sentimos, pero no tienes los permisos necesarios para acceder a esta sección. 
            Si crees que esto es un error, por favor contacta al administrador de tu sistema.
          </p>

          <div className="flex flex-col gap-3">
            <Button 
              onClick={() => navigate("/dashboard")}
              className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white border-0 h-12 rounded-xl font-medium shadow-lg shadow-blue-500/20"
            >
              <Home className="mr-2 h-4 w-4" />
              Volver al Dashboard
            </Button>
            
            <Button 
              variant="ghost" 
              onClick={() => window.history.back()}
              className="text-slate-300 hover:text-white hover:bg-slate-800 h-12 rounded-xl"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Regresar
            </Button>
          </div>
        </div>
        
        <p className="mt-8 text-center text-slate-500 text-sm">
          Error 403 - Forbidden Access
        </p>
      </div>
    </div>
  );
}
